import { Component, Injector } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { SupportserviceService } from './supportservice.service';
import { BaseClass } from '../../utility/baseClass';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { isEmpty } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-supportverificationcationmodal',
  templateUrl: './supportverificationcationmodal.component.html',
  styleUrls: ['./supportverificationcationmodal.component.css']
})
export class SupportverificationcationmodalComponent extends BaseClass{
  supportloginform: FormGroup;
  logindetails:any
  validation_message={
        'organisation': [{ type: 'required', message: 'Organisation Name is required' }],
        'userid':[{ type: 'required', message: 'Email ID is required' }],
        'password':[{ type: 'required', message: 'Password is required' }]

  }
  orglist=[]
  constructor(private fb:FormBuilder,private supportservice:SupportserviceService,
     public ref: DynamicDialogRef,
        public override injector: Injector, public config: DynamicDialogConfig,
    
  ){
    super(injector);
    this.formInitialize();
        const dataFromParent = this.config.data;
              this.logindetails = dataFromParent.logindata;


    this.getOrganisationList();
  }
   formInitialize() {
      this.supportloginform = this.fb.group({
        organisation:['',Validators.compose([Validators.required])],
        userid: ['', Validators.compose([Validators.required, Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
        password: [''] // Ensure this field is included if needed
      });
    }
    login(){
      if(this.supportloginform.invalid){
        this.validateAllFormFields(this.supportloginform);
      }else{
        this.supportservice.logininassupport(this.supportloginform.value).subscribe(res=>{
          // console.log(res.userdata.isEmpty(),"is empty");
          if(res.userdata.token!==undefined){
           const data=JSON.stringify(res.userdata);
           const assignproducts=res.userdata.assignedproduct;           
          localStorage.setItem('userdata',data);
          const loginTime = new Date().toISOString(); // or just new Date()
          
          localStorage.setItem('loginTime', loginTime);
          window.location.href = location.origin + assignproducts[0].defaultpagemircroservice+"#/"
        // window.location.href = location.origin + '/registration/'+"#/"

        }
          else{
            Swal.fire("Wrong Email ID or password or ghost login is disabled");
          }
          
        })
      }
    }
    dismiss(){
  this.ref.close()
    }
     getOrganisationList() {
    this.supportservice.getorglist().subscribe(res => {
      this.orglist = res.orgdata;
    })
  }

}
